import styled, { css } from 'styled-components';
import { Breakpoints } from '../../../styled/constants';
import { FlexCenterAligned, FlexColumn } from '../../../styled/common';
import {
  Slide,
  SlideImage,
  Slider,
  SliderWrapper
} from '../GallerySlider/styled';
import { Typography } from '../Typography';
import {
  GalleryCarouselImage,
  GalleryCarouselImageWrapper
} from '../GalleryCarousel/styled';
import { getSafeAreaValue } from '../../../styled/theme/helpers/getSafeAreaValue';

export const ModalContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const modalStyles = css`
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  flex-direction: column;
  height: 100%;
  z-index: 70003;

  @media (min-width: ${Breakpoints.tablet}px) {
    max-width: 100%;
    max-height: 100%;
    height: 100%;
    width: 100%;
    border-radius: 0;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding-bottom: 20px;
  }
`;

export const SliderContent = styled.div`
  position: relative;
  flex: 1 1 0;
  min-height: 0;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding-top: 20px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    padding: 10px max(60px, calc((100% - 1280px) / 2)) 20px;
    max-height: calc(100vh - 140px);
  }

  ${SliderWrapper} {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  ${Slider} {
    cursor: auto;
  }
`;

const ClickZone = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 50%;
  z-index: 2;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
`;

export const ClickZoneLeft = styled(ClickZone)`
  left: 0;
`;

export const ClickZoneRight = styled(ClickZone)`
  right: 0;
`;

export const Header = styled(FlexColumn)`
  height: ${({ theme }) => getSafeAreaValue(theme, 'top', 45, 10)};
  flex: 0 0 auto;
  justify-content: end;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 70px;
  }
`;

const GalleryActionButton = styled(FlexCenterAligned)`
  width: 60px;
  height: 90px;
  position: absolute;
  cursor: pointer;
  z-index: 3;

  @media (hover: hover) {
    &:hover {
      background-color: rgba(255, 255, 255, 0.15);
      transition: background-color 0.3s ease;
    }
  }
`;

const ArrowButton = styled(GalleryActionButton)`
  top: 50%;
  transform: translate(0, -50%);
  background-image: url('/static/images/item/arrow-left.svg');
  background-size: 16px 24px;
  background-repeat: no-repeat;
  background-position: center;
`;

export const LeftArrow = styled(ArrowButton)`
  left: 0;
  border-radius: 0 7px 7px 0;
`;

export const RightArrow = styled(ArrowButton)`
  right: 0;
  transform: translate(0, -50%) rotate(180deg);
  border-radius: 0 7px 7px 0;
`;

export const sliderStyles = css`
  height: 100%;

  @media (min-width: ${Breakpoints.tablet}px) {
    height: 100%;
  }

  ${Slide} {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
  }

  ${SlideImage} {
    margin: 0;
    user-select: none;
  }
`;

export const ModalFooter = styled.div<{ $isCentered?: boolean }>`
  flex: 0 0 auto;

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 50px;

    ${({ $isCentered }) =>
      $isCentered &&
      css`
        display: flex;
        justify-content: center;

        ${GalleryCarouselImageWrapper} {
          margin-left: 0;
        }

        ${GalleryCarouselImage}:last-of-type {
          margin-right: 0;
        }
      `}
  }
`;

export const SliderInfo = styled(FlexCenterAligned)`
  @media (max-width: ${({ theme }) => theme.smallDesktopBreakpoint}) {
    display: none;
  }

  background-color: rgba(0, 0, 0, 0.75);
  padding: 5px 10px;
  border-radius: 50px;
  position: absolute;
  z-index: 10;
  left: 50%;
  transform: translateX(-50%);
  bottom: 25px;
`;

export const SliderInfoText = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.white};
`;

export const carouselStyles = css`
  margin-top: 0;

  ${GalleryCarouselImageWrapper} {
    margin-left: 20px;
  }

  ${GalleryCarouselImage}:last-of-type {
    margin-right: 20px;
  }
`;
